<template>
    <div>
        <div>
            <div :class="{'flex items-center' : screenSize !== 'xs'}">
                <div class="">
                    <p-radio @change="resetAddress" value="existing" type="radio" class="formLabel p-pulse" name="address" color="warning" v-model="address"><b>Existing address</b></p-radio>
                </div>
                
                <Dropdown v-if="address === 'existing'" class="mt2-xs w-50-m w-40-l" @input="addressSelected($event)">
                    <option value="" disabled selected>Select an address</option>
                    <option  v-for="(address, index) in addresses" :key="index" :value="index">{{address.address}}</option>    
                </Dropdown>
            </div>
            <p-radio @change="resetAddress" value="other" type="radio" class="mt3 mb4 formLabel p-pulse" name="address" color="warning" v-model="address"><b>New address</b></p-radio>
        </div>
        <div v-if="address === 'other'">
            <h6 class="mt2">Address details</h6>
            <FullAddressInput v-model="location" class="pt3 bb b--light-gray" @input="$emit('input', location)" />
        </div>
    </div>
</template>

<script>
import FullAddressInput from '@/components/global/FullAddressInput.vue';
import Dropdown from '@/components/controls/Dropdown.vue';
import { mapState, mapActions } from 'vuex';

export default {
    data() {
        return {
            address: null
        };
    },
    props: {
        location: {
            type: Object
        }
    },
    components: {
        FullAddressInput,
        Dropdown
    },
    computed: {
        ...mapState('accountInfo', ['addresses']),
        screenSize() {
            return this.$mq;
        }
    },
    methods: {
        ...mapActions('accountInfo', ['getAddressInfo']),
        resetAddress() {
            this.location.id = null;
            this.location.address = '';
            this.location.postalCode = '';
            this.location.city = 'Winnipeg';
            this.location.province = 'Manitoba';
        },
        addressSelected(index) {
            this.location.id = this.addresses[index].id;
            this.location.address = this.addresses[index].address;
            this.location.postalCode = this.addresses[index].postal_code;
            this.location.city = this.addresses[index].city;
            this.location.province = this.addresses[index].province;
            this.$emit('input', this.location);
        }
    },
    created: function() {
        this.getAddressInfo();
    }
};
</script>
